/* eslint-disable no-unused-vars */
import Vue from 'vue'
import store from './../store'
import Router from 'vue-router'
import Account from '@/views/layout/Account'
import Main from '@/views/layout/Main'
import Webview from '@/views/layout/Webview'
import LandingPage from '@/views/layout/LandingPage'
import Proxy from '@/views/proxy/index'
import ResetPassword from '@/views/layout/ResetPassword'
import CheckoutCounter from '@/views/layout/CheckoutCounter'
import CheckoutCounterBCPay from '@/views/layout/CheckoutCounterBCPay'
import { showNotice, performKYCCheck } from '@/utils/tool'
import i18n from '@/i18n'

Vue.use(Router)

export const routerMap = [
  {
    path: '/critical',
    component: () => import('@/views/errorPage/critical'),
    name: 'Critical'
  },
  {
    // 行銷廣告
    component: LandingPage,
    path: '/landingPage2000',
    beforeEnter: (to, from, next) => {
      import('@/assets/css/landing-page.css')
        .then(() => {
          next()
        })
        .catch(err => {
          console.error('Failed to load CSS:', err)
          next()
        })
    }
  },
  {
    // 行銷廣告
    component: LandingPage,
    path: '/landingPage3000',
    beforeEnter: (to, from, next) => {
      import('@/assets/css/landing-page.css')
        .then(() => {
          next()
        })
        .catch(err => {
          console.error('Failed to load CSS:', err)
          next()
        })
    }
  },
  {
    // 行銷廣告
    component: LandingPage,
    path: '/landingPage4000',
    beforeEnter: (to, from, next) => {
      import('@/assets/css/landing-page.css')
        .then(() => {
          next()
        })
        .catch(err => {
          console.error('Failed to load CSS:', err)
          next()
        })
    }
  },
  {
    // 行銷廣告
    component: LandingPage,
    path: '/landingPage5000',
    beforeEnter: (to, from, next) => {
      import('@/assets/css/landing-page.css')
        .then(() => {
          next()
        })
        .catch(err => {
          console.error('Failed to load CSS:', err)
          next()
        })
    }
  },
  {
    // 代理頁面
    component: Proxy,
    path: '/affiliate'
  },
  {
    // 忘記密碼-重設密碼
    component: ResetPassword,
    path: '/forgot_password/:username/:validate_code'
  },
  {
    // 收銀台
    component: CheckoutCounter,
    path: '/ubifrost',
    beforeEnter: (to, from, next) => {
      if (to.fullPath.includes('/ubifrost')) {
        // 如果包含，則進行某些處理或重定向
        next() // 或者你可以進行其他操作
      }
    }
  },
  {
    // 收銀台_BCPay
    component: CheckoutCounterBCPay,
    path: '/bigcat',
    beforeEnter: (to, from, next) => {
      if (to.fullPath.includes('/bigcat')) {
        // 如果包含，則進行某些處理或重定向
        next()
      }
    }
  },
  {
    component: Main,
    path: '/',
    children: [
      {
        path: 'newlanding:bonusAmount',
        component: () => import('@/views/layout/newLanding'),
        name: 'Land2',
        meta: { needLogin: false },
        beforeEnter: (to, from, next) => {
          import('@/assets/css/newLanding.css')
            .then(() => {
              next()
            })
            .catch(err => {
              console.error('Failed to load CSS:', err)
              next()
            })
        }
      },
      {
        path: 'event',
        component: () => import('@/views/event/index'),
        name: 'Event',
        meta: { menuName: 'Event', needCookie: true,
          metaInfo: {
            title: '勝WIN｜最高還元率のオンラインカジノ&リベート・フリースピン',
            description: '勝WINは、最高還元率を誇るオンラインカジノ！豪華ボーナス＆爆速出金で圧倒的なプレイ体験を提供。多彩なパチンコ・パチスロゲームと毎日ボーナスを今すぐ楽しもう！',
            keywords: 'リベートボーナス,ウェルカムボーナス,フリースピン'
          },
          seoPageType: 'event'
        }
      },
      {
        path: 'deposit',
        component: () => import('@/views/payment/deposit'),
        name: 'Deposit',
        meta: { needLogin: true, menuName: 'Deposit', needCookie: true }
      },
      {
        path: 'buy-cryptocurrency',
        component: () => import('@/views/payment/buyCryptocurrency'),
        name: 'BuyCryptocurrency',
        meta: { needLogin: true, menuName: 'BuyCryptocurrency', needCookie: true }
      },
      {
        path: 'withdrawal',
        component: () => import('@/views/payment/withdrawal'),
        meta: { needLogin: true, menuName: 'Withdrawal', needCookie: true },
        beforeEnter: (to, from, next) => {
        // 檢查用戶是否需要 KYC 驗證
          const walletType = store.state.app.selectedWallet.wallet_type
          let type = 2
          if (walletType !== 'main' || walletType !== 'bonus') {
            type = 3
          }

          const mockRouter = {
            replace: (route) => next(route),
            push: (route) => next(route)
          }

          if (!performKYCCheck(mockRouter, type, true)) {
            next()
          }
        }
      },
      {
        path: 'points',
        component: () => import('@/views/shop/index'),
        children: [
          {
            path: 'all-bonus',
            component: () => import('@/views/shop/allBonus'),
            name: 'AllBonus',
            meta: { needLogin: true, menuName: 'AllBonus' }
          },
          {
            path: 'coupon',
            beforeEnter: (to, from, next) => {
              if (store.getters.memberInfo.member_type === 3) {
                next('/points/all-bonus')
                showNotice(i18n.t('Bao.lite_limit'))
              } else {
                next()
              }
            },
            component: () => import('@/views/shop/coupon'),
            name: 'Coupon',
            meta: { needLogin: true, menuName: 'Coupon', isLitePlayer: true }
          }
        ]
      },
      {
        path: 'user',
        component: () => import('@/views/user/head'),
        children: [
          {
            path: '',
            component: () => import('@/views/user/personal'),
            name: 'Personal',
            meta: { needLogin: true, menuName: 'Personal', needCookie: true }
          },
          {
            path: 'edit',
            component: () => import('@/views/user/edit'),
            name: 'EditName'
          },
          {
            path: 'KYC',
            component: () => import('@/views/user/KYC'),
            name: 'KYC'
          },
          {
            path: 'verify',
            component: () => import('@/views/user/verify'),
            name: 'Verify'
          },
          {
            path: 'letter',
            component: () => import('@/views/user/letter'),
            meta: { needLogin: true, menuName: 'Letter', needCookie: true },
            name: 'Message'
          },
          {
            path: 'transaction-history',
            component: () => import('@/views/user/transactionHistory'),
            meta: { needLogin: true, menuName: 'TransactionHistory', needCookie: true },
            name: 'TransactionHistory'
          },
          {
            path: 'wallet-history',
            component: () => import('@/views/transaction/mobile'),
            meta: { needLogin: true, menuName: 'WalletHistory', needCookie: true },
            name: 'WalletHistory'
          },
          {
            path: 'bank',
            component: () => import('@/views/bank/index'),
            meta: { needLogin: true, menuName: 'Bank', needCookie: true },
            name: 'Bank'
          },
          {
            path: 'bank/create',
            component: () => import('@/views/bank/create'),
            meta: { needLogin: true, menuName: 'BankCard', needCookie: true },
            name: 'BankCard'
          },
          {
            path: 'news',
            component: () => import('@/views/user/news'),
            meta: { menuName: 'News', needCookie: true },
            name: 'News'
          },
          // {
          //   path: 'friend',
          //   component: () => import('@/views/user/friend'),
          //   name: 'UserFriend',
          //   meta: { needLogin: true, menuName: 'UserFriend', needCookie: true }
          // },
          {
            path: 'event/me',
            component: () => import('@/views/event/me'),
            meta: { needLogin: true, menuName: 'EventMe', needCookie: true },
            name: 'Bonus'
          },
          {
            path: 'event/me/:task_id',
            component: () => import('@/views/event/me'),
            meta: { needLogin: true, menuName: 'EventMe', needCookie: true },
            name: 'BonusDetail'
          }
        ]
      },
      {
        path: 'vip',
        component: () => import('@/views/vip/index'),
        name: 'VipIndex',
        meta: { needCookie: true, needRedirect: true,
          metaInfo: {
            title: '勝WIN｜ハイリベート業界最高峰',
            description: '業界トップクラスのリベート率を実験',
            keywords: 'リベート,昇格ボーナス,誕生日ボーナス'
          },
          seoPageType: 'vip'
        }
      },
      {
        path: 'share',
        name: 'Share',
        component: () => import('@/views/share')
      },
      {
        path: 'personal/data/modal',
        name: 'PersonalDataModal',
        component: () => import('@/components/modal/personalDataModal')
      },
      {
        path: ':seo_path?',
        component: () => import('@/views/index'),
        name: 'home',
        meta: { needCookie: true, needRedirect: true, seoPageType: 'home' }
      }
    ]
  },
  {
    component: Account,
    path: '/',
    children: [
      {
        path: '/user/register',
        component: () => import('@/views/user/register'),
        name: 'Register'
      }
    ]
  },
  {
    component: Main,
    path: '/page',
    children: [
      {
        path: 'support',
        component: () => import('@/views/page/support'),
        name: 'Support',
        meta: { needCookie: true }
      },
      {
        path: 'privacy',
        component: () => import('@/views/page/privacy'),
        name: 'PagePrivacy',
        meta: { needCookie: true }
      },
      {
        path: 'rule',
        component: () => import('@/views/page/rule'),
        name: 'PageRule',
        meta: { needCookie: true }
      },
      {
        path: 'sports-rule',
        component: () => import('@/views/page/sportsRule'),
        name: 'PageSportsRule',
        meta: { needCookie: true }
      },
      {
        path: 'agent',
        component: () => import('@/views/page/agent'),
        name: 'PageAgent',
        meta: { needCookie: true }
      },
      {
        path: 'terms',
        component: () => import('@/views/page/terms'),
        name: 'PageTerms',
        meta: { needCookie: true }
      },
      {
        path: 'cookie-policy',
        component: () => import('@/views/page/cookiePolicy'),
        name: 'PageCookiePolicy',
        meta: { needCookie: true }
      },
      {
        path: 'sup-how-to-register',
        component: () => import('@/views/page/sup/sup-how-to-register'),
        meta: { needCookie: true,
          metaInfo: {
            title: '勝WINの登録方法を図解解説 【簡単5ステップ】| KatsuWIN',
            keywords: '勝WIN, 登録方法簡単, 登録',
            description: '勝WINの登録に必要なのはユーザー情報とメールアドレスのみ。メール認証のみで簡単5ステップ 1分以内でアカウントの作成は完了。オンラインパチンコパチスロ業界最大台数の勝ウィンに今すぐ登録'
          }
        }
      },
      {
        path: 'sup-how-to-login',
        component: () => import('@/views/page/sup/sup-how-to-login'),
        meta: { needCookie: true, metaInfo: {
          title: '勝WINのログイン方法｜簡単4ステップ',
          keywords: '勝WIN, ログイン方法',
          description: '勝WINへのログイン方法を詳しく解説。簡単4ステップですぐに始められます。今すぐログインして、多彩なゲームをお楽しみください。'
        }}
      },
      {
        path: 'sup-payment-method',
        component: () => import('@/views/page/sup/sup-payment-method'),
        meta: { needCookie: true, metaInfo: {
          title: '勝WINの入出金方法 | 決済手段のご案内',
          keywords: '勝WIN, 入出金方法, 銀行振込,USDT,',
          description: '勝WINでは、銀行振込、電子決済、USDTなど多様な入出金方法をご用意。すべて手数料無料で即時処理が可能です。安全で迅速な決済手段について詳しくご紹介します。'
        }}
      },
      {
        path: 'sup-account-binding',
        component: () => import('@/views/page/sup/sup-account-binding'),
        meta: { needCookie: true, metaInfo: {
          title: '勝WINのアカウント連携方法 | 簡単ステップで連携完了',
          keywords: '勝WIN, アカウント連携, 連携方法',
          description: '勝WINのアカウント連携方法を詳しく解説。簡単なステップで連携を完了し、スムーズにゲームをお楽しみいただけます。'
        }}
      },
      {
        path: 'sup-wallet',
        component: () => import('@/views/page/sup/sup-wallet'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-event-bonus',
        component: () => import('@/views/page/sup/sup-event-bonus'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-about-shop',
        component: () => import('@/views/page/sup/sup-about-shop'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-coupon',
        component: () => import('@/views/page/sup/sup-coupon'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-vip-class-upgrading',
        component: () => import('@/views/page/sup/sup-vip-class-upgrading'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-verify-your-account',
        component: () => import('@/views/page/sup/sup-verify-your-account'),
        meta: { needCookie: true, metaInfo: {
          title: '勝WINの本人確認の方法',
          keywords: '勝WIN, アカウント認証, 本人確認, KYC',
          description: '勝WINでの本人確認の手順を詳しく解説。必要な書類や手続き方法をご確認ください。'
        }}
      },
      {
        path: 'sup-faq',
        component: () => import('@/views/page/sup/sup-faq'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-self-restraint',
        component: () => import('@/views/page/sup/sup-self-restraint'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-responsible-gaming',
        component: () => import('@/views/page/sup/sup-responsible-gaming'),
        meta: { needCookie: true }
      },
      {
        path: 'sup-recommended-games',
        component: () => import('@/views/page/sup/sup-recommended-games'),
        meta: { needCookie: true }
      }
    ]
  },
  {
    component: Webview,
    path: '/web',
    children: [
      {
        path: 'deposit-record',
        component: () => import('@/views/payment/depositRecord'),
        meta: { needLogin: true }
      },
      {
        path: 'transaction',
        component: () => import('@/views/transaction/main'),
        meta: { needLogin: true }
      },
      {
        path: 'transaction/bonus',
        component: () => import('@/views/transaction/bonus'),
        meta: { needLogin: true }
      },
      {
        path: 'transaction/commission',
        component: () => import('@/views/transaction/commission'),
        meta: { needLogin: true }
      },
      {
        path: 'user/bet',
        component: () => import('@/views/user/bet'),
        meta: { needLogin: true }
      },
      {
        path: 'event/me',
        component: () => import('@/views/event/me'),
        meta: { needLogin: true }
      },
      {
        path: 'event/me/:task_id',
        component: () => import('@/views/event/me'),
        meta: { needLogin: true, menuName: 'EventMe' }
      }
    ]
  }
]

export default new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.name === 'Index') return
    else return { y: 0 }
  },
  routes: routerMap
})
